import { datadogRum } from '@datadog/browser-rum';
import { devLog } from '@/helpers/dev';

export function logPaymentEvent(
  eventName: string,
  details: Record<string, any>,
) {
  devLog(eventName, { timestamp: new Date().toISOString(), ...details });

  datadogRum.addAction(eventName, {
    timestamp: new Date().toISOString(),
    userAgent: navigator.userAgent,
    ...details,
  });
}
